import { deleteData, getData, postData } from "./apiInstance";
import { AxiosResponse } from "axios";
import {
  AddFolderTypesPayload,
  DeleteFileFolderPayloadType,
  GetChildFoldersTypePayload,
  HideFileFolderPayloadType,
  RenameFileTypePayload,
  RenameFolderTypePayload,
  UploadFileTypesPayload,
} from "../commonTypes/fileManagerTypes";
import { getCSRFToken } from "../utils/commonFunctions";

export async function createFolderApi(
  data: AddFolderTypesPayload
): Promise<AxiosResponse> {
  const { parent_id, folder_name, folder_path, token, client_code } = data;

  const finalData = {
    parent_id,
    folder_name,
    folder_path,
    client_code,
  };

  return postData(`drive/dir/`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
       "x-csrf-token":  getCSRFToken()
    },
  });
}

export async function uploadFileInDriveApi(
  data: UploadFileTypesPayload
): Promise<AxiosResponse> {
  const { client_code, folder_id, token, file_name, file_type, file_url } =
    data;

  let finalData = {
    client_code,
    file_name,
    file_type,
    file_url,
  };

  return postData(`drive/document/${Number(folder_id)}`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
       "x-csrf-token":  getCSRFToken()
    },
  });
}

export async function getChildFoldersApi(
  data: GetChildFoldersTypePayload
): Promise<AxiosResponse> {
  const { folder_id, token, client_code, search_term } = data;
  return getData(`drive/dir/${parseInt(folder_id)}`, {
    params: {
      client_code,
      ...(search_term && { search_term }),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function renameFolderApi(
  data: RenameFolderTypePayload
): Promise<AxiosResponse> {
  const { folder_id, folder_name, token } = data;

  return postData(
    `drive/dir/edit/${folder_id}`,
    { folder_name },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
         "x-csrf-token":  getCSRFToken()
      },
    }
  );
}

export async function renameFileApi(
  data: RenameFileTypePayload
): Promise<AxiosResponse> {
  const { id, file_name, token, client_code } = data;
  let finalData = {
    id,
    file_name,
    client_code,
  };

  return await postData(`drive/file/rename`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
       "x-csrf-token":  getCSRFToken()
    },
  });
}

export async function deleteFileAndFolderAPi(
  data: DeleteFileFolderPayloadType
): Promise<AxiosResponse> {
  const { token, id, type, client_code } = data;
  const finalParams = {
    id,
    type,
    client_code,
  };
  return await deleteData(`drive/file-folder/delete`, {
    params: { ...finalParams },
    headers: {
      "user-token": token,
      "Content-Type": "application/json",
       "x-csrf-token":  getCSRFToken()
    },
  });
}

export async function hideFileFoldersApi(
  data: HideFileFolderPayloadType
): Promise<AxiosResponse> {
  const {token, client_code, type,id ,to_hide } = data;
  let finalData = {
    client_code,
      type,
      id,
      to_hide
  };

  return await postData(`drive/file-folder/hide`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
       "x-csrf-token":  getCSRFToken()
    },
  });
}